<p-popover #ncpo>
  <input
    type="text"
    #botNameInput
    class="form-control"
    [(ngModel)]="this.rss.botConfig.name"
    [ngModelOptions]="{updateOn: 'blur'}"
    (blur)=" this.editBotNameMode = false"
    (ngModelChange)="this.saveNameToBotConfig(); this.editBotNameMode = false"
    id="botName"
  >
</p-popover>
<p-drawer
  [(visible)]="showExportPanel"
  appendTo="body"
  header="Share & Export "
  [style]="{width: '40rem'}"
  position="right"
>
  <app-export-drawer-content (closeDrawer)="showExportPanel = false"></app-export-drawer-content>
</p-drawer>

<!--
#
style="position: sticky; z-index: 120; background-color: white; top: 0;

""-->
<div [class.glow]="this.isScrolled">
  <div class="row p-1 align-items-baseline">
    <div class="col-auto">
      <div class="row">
        <div class="col-auto pe-0">
          <a
            class="lock-insensitive flex-grow-0 cursor-pointer d-inline text-decoration-none dark-link"
            (click)="this.backToHome()"
            [routerLink]="['/', 'bot-admin']"
          >
            Projekte
          </a>
        </div>
        <div class="col-auto px-0">
          <i class="ri-arrow-right-s-line text-muted"></i>
        </div>
        <div class="col-auto px-0">
          <a
            class="cursor-pointer d-inline text-decoration-none dark-link"
            (click)="this.backToHome()"
            [routerLink]="this.getProjectRoute()"
          >
            {{this.projectService.selectedProject! | projectName }}
          </a>
        </div>
        <div class="col-auto px-0">
          <i class="ri-arrow-right-s-line text-muted"></i>
        </div>
        <div class="col-auto px-0">

          <!---NEUER SHIT-->

          <!-- <app-is-template-header *ngIf="this.rss.botConfig.isTemplate"></app-is-template-header> -->
          <ng-container>
            <span>
              <div class="col">
                <div
                  class="input-group mb-2"
                  container="body"
                >
                  @if (!this.editBotNameMode) {
                  <span class="botNameHeadline">{{this.rss.botConfig.name}} <i
                      class="ri-edit-2-fill"
                      (click)="ncpo.show($event) ; this.backupBotName = this.rss.botConfig.name"
                    ></i></span>
                  }
                </div>
              </div>
            </span>
            <div class="row">
              <!-- <div class="col-auto text-end me-n1 align-content-center text-secondary">
              <div><ng-container i18n="@@bot-owner-from">von</ng-container>: {{this.rss.botConfig.creatorName}}</div>
            </div> -->
              <div class="col">
              </div>
            </div>
          </ng-container>

          <!-- ENDE NEUER SHIT-->
        </div>
      </div>
    </div>
    <div class="col">
      <app-admin-position-bubble
        [position]="this.rss.botConfig._id"
        [reinitBubblesAfterDelay]="true"
      ></app-admin-position-bubble>
    </div>
    <div class="col-auto">
      <div class="row align-items-baseline header-actions-row">
        <div class="col-auto">
          <app-preview #preview></app-preview>
        </div>

        <div class="col-auto">
          <p-button
            size="small"
            severity="secondary"
            icon="ri-restart-line"
            (onClick)="preview.resetBot()"
            pTooltip="Bot zurücksetzen"
            i18n-pTooltip="@@preview-reset-tooltip"
            tooltipPosition="bottom"
          ></p-button>
        </div>

        <div class="col-auto">
          @if (!this.rss.botConfig.isPublic) {

          <p-button
            size="small"
            severity="primary"
            icon="ri-share-fill"
            iconPos="right"
            (onClick)="showExportPanel = true"
            i18n-label="@@share"
            label="Teilen"
          ></p-button>
          }
          @else
          {
          <p-button
            size="small"
            severity="primary"
            (onClick)="showExportPanel = true"
            i18n-label="@@shared"
            label="Geteilt"
          >
            <ng-template pTemplate="content">
              <span i18n="@@shared">Geteilt</span>
              <i
                [ngClass]="this.rss.botConfig.isPwProtected ? 'ri-lock-password-fill share-status-icon share-status-icon-lock' : 'ri-checkbox-circle-fill share-status-icon'"></i>
            </ng-template>
          </p-button>
          }
        </div>
      </div>
    </div>
  </div>
</div>